export default class authorisationService {

  authStripeConnectedAccount(authorisationCode) {
    this.props.authAccount(authorisationCode)
  }

}
